import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { PaymentMethodEntity, PaymentMethodType } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of, tap } from 'rxjs';


@Component({
  selector: 'payment-method-picker',
  templateUrl: './payment.method.picker.component.html',
  styleUrls: ['./payment.method.picker.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: PaymentMethodPickerComponent, multi: true }
  ]
})
export class PaymentMethodPickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: PaymentMethodEntity[];
  @Input() public type = PaymentMethodType.Manual;
  @Input() public companyId: string;
  @Input() public placeholder = '<Payment Method>';
  @Input() public appendTo;
  @Input() public multiple: boolean;
  @Input() public clearable = true;


  public data$: Observable<PaymentMethodEntity[]>;
  public PickerItemStyle = PickerItemStyle;


  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() {

    if (this.fetch === PickerFetch.Manual) {

      this.data$ = of(this.data);

    } else {

      if (this.companyId && this.type) {

        this.data$ = this.getData();

      } else {

        this.data$ = this.getAll();

      }
    }


  }

  private getData(): Observable<PaymentMethodEntity[]> {

    switch (this.type) {
      case PaymentMethodType.Manual: {
        return this.http.get<PaymentMethodEntity[]>(`/api/picker/payment-methods/manual/${this.companyId}`);
      }
      case PaymentMethodType.Online: {
        return this.http.get<PaymentMethodEntity[]>(`/api/picker/payment-methods/online/${this.companyId}`);
      }
    }

  }

  private getAll(): Observable<PaymentMethodEntity[]> {

    return this.http.get<PaymentMethodEntity[]>(`/api/picker/payment-methods`);

  }

}

